import { useEffect, useState } from "react";
import { X, Share, Plus } from "lucide-react";

const DISMISSED_KEY = "pwa_install_dismissed_v1";

const isIOS = () => {
  const ua = navigator.userAgent;
  return (
    (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) ||
    (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1)
  );
};

const isInStandaloneMode = () =>
  navigator.standalone === true ||
  window.matchMedia("(display-mode: standalone)").matches;

const isMobileOrTablet = () => navigator.maxTouchPoints > 0;

const InstallPrompt = () => {
  const [show, setShow] = useState(false);
  const [isIOSDevice, setIsIOSDevice] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  useEffect(() => {
    if (!isMobileOrTablet()) return;
    if (isInStandaloneMode()) return;
    if (localStorage.getItem(DISMISSED_KEY)) return;

    const ios = isIOS();
    setIsIOSDevice(ios);

    if (ios) {
      setShow(true);
    } else {
      const handler = (e) => {
        e.preventDefault();
        setDeferredPrompt(e);
        setShow(true);
      };
      window.addEventListener("beforeinstallprompt", handler);
      return () => window.removeEventListener("beforeinstallprompt", handler);
    }
  }, []);

  const handleInstall = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === "accepted") dismiss();
    }
  };

  const dismiss = () => {
    localStorage.setItem(DISMISSED_KEY, "1");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 mx-auto max-w-sm">
      <div className="rounded-xl bg-[#1a1a2e] border border-[#FF2A6D]/30 text-white shadow-2xl p-4">
        <div className="flex items-start justify-between gap-3">
          <div className="flex items-center gap-3">
            <img src="/icon-192.png" alt="B&S Hub" className="w-10 h-10 rounded-xl" />
            <div>
              <p className="font-semibold text-sm">Tilføj som app</p>
              <p className="text-[13px] text-white/60 mt-0.5">Hurtig adgang til Beauty & Style Hub</p>
            </div>
          </div>
          <button onClick={dismiss} className="text-white/40 hover:text-white mt-0.5 shrink-0">
            <X className="h-4 w-4" />
          </button>
        </div>

        {isIOSDevice ? (
          <div className="mt-3 text-[13px] text-white/70 space-y-1.5 border-t border-white/10 pt-3 text-center">
            <p>Tryk på <Share className="inline h-3.5 w-3.5 mb-0.5" /> Del-knappen i Safari</p>
            <p>Vælg <strong className="text-white">"Føj til hjemmeskærm"</strong> <Plus className="inline h-3.5 w-3.5 mb-0.5" /></p>
          </div>
        ) : (
          <button
            onClick={handleInstall}
            className="mt-3 w-full rounded-lg bg-[#FF2A6D] text-white font-semibold text-sm py-2 hover:bg-[#FF2A6D]/90 transition-colors"
          >
            Tilføj til hjemmeskærm
          </button>
        )}
      </div>
    </div>
  );
};

export default InstallPrompt;
